import { SupervisorReportItem } from '../types/sales'; // パスは実際のプロジェクト構造に合わせて調整

// SupervisorReportItem 型のテストデータを生成する関数
function generateMockSupervisorData(): SupervisorReportItem[] {
  // 担当者名のリスト（10名分）
  const supervisorNames = [
    '佐藤', '鈴木', '高橋', '田中', '伊藤', 
    '渡辺', '山本', '中村', '小林', '加藤'
  ];
  
  // 担当者ごとのデータを生成
  const supervisorData: SupervisorReportItem[] = supervisorNames.map(name => {
    // ランダムな値を生成
    const totalSales = Math.floor(Math.random() * 5000000) + 500000; // 50万円〜550万円
    const grossProfitRate = Math.floor(Math.random() * 40) + 15; // 15%〜55%
    const grossProfit = Math.floor(totalSales * (grossProfitRate / 100));
    const projectCount = Math.floor(Math.random() * 10) + 1; // 1〜10件
    const supervisorAllowance = Math.floor(Math.random() * 50000) + 10000; // 1万円〜6万円
    const finalProfit = grossProfit - supervisorAllowance;
    const finalProfitRate = (finalProfit / totalSales) * 100;
    
    // 型に合わせて適切な型で返す
    return {
      supervisor_name: name,
      total_sales: totalSales,          // 数値型で返す
      gross_profit: grossProfit,        // 数値型で返す
      gross_profit_rate: grossProfitRate,
      project_count: projectCount,
      supervisor_allowance: supervisorAllowance,  // 数値型で返す
      final_profit: finalProfit,        // 数値型で返す
      final_profit_rate: finalProfitRate
    };
  });
  
  // 合計行の計算
  const totalSales = supervisorData.reduce((sum, item) => sum + item.total_sales, 0);
  const totalGrossProfit = supervisorData.reduce((sum, item) => sum + item.gross_profit, 0);
  const totalProjectCount = supervisorData.reduce((sum, item) => sum + item.project_count, 0);
  const totalSupervisorAllowance = supervisorData.reduce((sum, item) => sum + item.supervisor_allowance, 0);
  const totalFinalProfit = supervisorData.reduce((sum, item) => sum + item.final_profit, 0);
  
  const totalGrossProfitRate = (totalGrossProfit / totalSales) * 100;
  const totalFinalProfitRate = (totalFinalProfit / totalSales) * 100;
  
  // 合計行を追加
  supervisorData.push({
    supervisor_name: '合計',
    total_sales: totalSales,
    gross_profit: totalGrossProfit,
    gross_profit_rate: totalGrossProfitRate,
    project_count: totalProjectCount,
    supervisor_allowance: totalSupervisorAllowance,
    final_profit: totalFinalProfit,
    final_profit_rate: totalFinalProfitRate
  });
  
  return supervisorData;
}

// モックデータ生成
const mockSupervisorReport = generateMockSupervisorData();

// コンソールに出力 (開発時のデバッグ用)
// console.log(JSON.stringify(mockSupervisorReport, null, 2));

// salesReportService のモックとして使用する例
// モックサービスの実装例
const mockSalesReportService = {
  getSupervisorReport: async (startMonth: string, endMonth: string, token?: string) => {
    // API呼び出しの遅延をシミュレート
    await new Promise(resolve => setTimeout(resolve, 500));
    return mockSupervisorReport;
  }
};

export { mockSupervisorReport, mockSalesReportService, generateMockSupervisorData };